import Tab, { TabProps } from '@mui/material/Tab';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface LinkTabProps extends TabProps<'a'> {
    label?: string;
    href?: string;
}

export function LinkTab(props: LinkTabProps) {
    const navigate = useNavigate();

    const handleClick: React.MouseEventHandler<HTMLAnchorElement> = React.useCallback(
        event => {
            event.preventDefault();
            navigate(props.href);
        },
        [props.href, navigate]
    );

    return <Tab component="a" onClick={handleClick} {...props} />;
}
